/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { useContext } from "react";

import Button, {
  BUTTON_COLORS,
  BUTTON_SIZES,
  BUTTON_VARIANTS
} from "@/components/Button/Button";
import Menu from "@/components/Menu/Menu";
import { useMenu } from "@/components/Table/hooks";
import LanguageContext from "@/context/language/LanguageContext";
import useLanguageConverter from "@/shared/hooks/useLanguageConverter";
import { LANGUAGES } from "@/shared/types";
import { useLoginDataStore } from "@/stores/useLoginDataStore";
import { useUserDataStore } from "@/stores/useUserDataStore";

import { LanguageIcon } from "@dotnet/telematics-design-system";

import LanguageList from "./LanguageList";

const LanguageSelection = () => {
  const { languages, language, setNewLanguage } = useContext(LanguageContext);
  const { handleLanguageChange } = useLanguageConverter();

  const userData = useUserDataStore(state => state.userData);
  const setIsUpdatedLanguage = useLoginDataStore(
    state => state.setIsUpdatedLanguage
  );

  const { anchorEl, handleCloseMenu, handleOpenMenu } = useMenu();

  const handleOnClick = (id: LANGUAGES) => {
    if (userData === null) {
      handleLanguageChange(id);
      setIsUpdatedLanguage(id);
      return;
    }
    return setNewLanguage(id);
  };

  return (
    <>
      <Button
        color={BUTTON_COLORS.White}
        size={BUTTON_SIZES.Small}
        variant={BUTTON_VARIANTS.IconLeft}
        icon={<LanguageIcon />}
        onClick={handleOpenMenu}
      >
        <span
          css={css({
            minWidth: "0",
            overflowX: "hidden",
            textOverflow: "ellipsis"
          })}
        >
          {languages.find(({ id }) => id === language)?.text}
        </span>
      </Button>

      <Menu
        open={Boolean(anchorEl)}
        onClose={handleCloseMenu}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center"
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center"
        }}
        slotProps={{
          list: {
            disableListWrap: true
          }
        }}
        css={css({
          "& .MuiMenu-paper": {
            width: "100%",
            maxHeight: "432px",
            maxWidth: "216px"
          }
        })}
      >
        <LanguageList externalOnClick={handleOnClick} />
      </Menu>
    </>
  );
};

export default LanguageSelection;
